import React, { useContext, useMemo, useRef, useState } from 'react';
import { AppContext } from '../App';
import { MDBRange } from 'mdb-react-ui-kit';
import { GlyphState, IdeaBoxEntry, TaskType } from 'konect-model';
import InterpolationSlider from './InterpolationSlider';
import { InterpolationEntry, InterpolationPoints } from '../../services/mxgraph-service';

export interface InterpolationMenuProps {
    onChange: any;
}

export default function InterpolationMenu(props: InterpolationMenuProps) {
    const { project } = useContext(AppContext);

    return <div className='interpolation-container'>
        {project.getIdeaboxEntriesUsedInGlyphs().filter(e => e.linkedCells.length > 0).map(e =>
            <InterpolationEntryView key={e.id} entry={e} onChange={props.onChange} />
        )}
    </div>
}

export interface InterpolationEntryViewProps {
    onChange: any;
}

function InterpolationEntryView(props: any) {
    const { project } = useContext(AppContext);
    const [position, setPosition] = useState(0);
    const interpolationPoints = useRef<any>({});
    const e : IdeaBoxEntry = props.entry;

    let allStates: GlyphState[] = useMemo(() => {
        let states : GlyphState[] = [];
        for (const glyph of project.glyphs) {
            states = [...states, ...glyph.states.filter(s => s.changes.find(c => e.linkedCells.find((id: string) => id === c.cellId)))]
        }
        return states;
    }, []);

    const filtered = useMemo(() => allStates.filter((s) => s.id !== "default"), [allStates]);

    if (filtered.length <= 0) {
        return <></>;
    }

    function interpolateState(state: GlyphState, points: InterpolationPoints) {
        interpolationPoints.current[state.id] = points;
        const slider = position === 0 ? 0.0000000001 : position;
        const s = new InterpolationEntry(e, allStates, interpolationPoints.current).getStateAtPosition(slider);
        props.onChange(s)
    }

    const updateSlider = (position: number) => {
        setPosition(position);
        const slider = position === 0 ? 0.0000000001 : position;
        const s = new InterpolationEntry(e, allStates, interpolationPoints.current).getStateAtPosition(slider);
        props.onChange(s)
    }
    
    return <div>
        <div className='header' style={{backgroundColor: e.type === TaskType.INFORMATION ? "var(--mdb-warning)" : "var(--mdb-primary)"}}>{e.task.name}</div>
        <MDBRange min={"0"} max={"1"} step={"0.01"} defaultValue={0} id="customRange" onChange={(event: any) => {updateSlider(parseFloat(event.target.value))}}/>
        {filtered.map((s, i) => <InterpolationSlider key={s.id} index={i} state={s} onChange={(points) => interpolateState(s, points)} sliderPosition={position} />)}
    </div>
}